import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, map, startWith } from 'rxjs/operators';
import { AdminTableCell } from '../admin-table-cell';

@Component({
    selector: 'mpro-atable-row',
    template: '<ng-content></ng-content>',
})
export class AdminTableRowComponent implements AfterContentInit {
    @ContentChildren(AdminTableCell)
    cells: QueryList<AdminTableCell>;
    cellItems$: Observable<AdminTableCell[]>;

    ngAfterContentInit(): void {
        this.cellItems$ = this.cells.changes
            .pipe(startWith(''))
            .pipe(delay(0))
            .pipe(map(() => this.cells.toArray()));
    }
}